import Vue from 'vue'
import Vuex from 'vuex'
import monitor from './modules/monitor'
import visualModule from './modules/visual'
import { getLang } from '@/assets/js/utils.js'
import { CLIENT_ID } from '@/configs'
import { isLocalServer, isIot1, isIot3 } from '@utils/utils'
import browserClient from '@apmplus/web'
import { THEME } from '@/utils/theme'
import { getQueryParams } from '@/utils/str.js';

const { VUE_APP_host, VUE_APP_picHost, VUE_APP_ipConfigOpen, NODE_ENV, VUE_APP_EDITION, VUE_APP_UPDATE_TIME, VUE_APP_MODE, VUE_APP_AI_LINK_1 } = process.env
const ip1 = window.ip1 || 'iot1'
const ip2 = window.ip2 || 'iot2'
const ip3 = window.ip3 || 'iot3'
const isInEurope = window.location.hostname.indexOf(ip1) > -1 // 判断是否欧洲环境

console.log('VUE_APP_AI_LINK_1',  process.env);

let region = 'cn';

if (VUE_APP_MODE.startsWith('iot1')) {
  region = 'eu';
} else if (VUE_APP_MODE.startsWith('iot3')) {
  region = 'sgp';
}


const starOnline = getLocalStoragItem('starOnline') == 1

const isNoLimit = JSON.parse(getLocalStoragItem('isNoLimit')) || false

const query = getQueryParams(window.location.href);
const isShowSide = !(query.hidenSide === 'true');

// 是否显示侧边栏
const isShowSidebar = isShowSide ;  // isShowSide && !isInXingCheng;

// 是否显示头部
// const isShowHeader =  !isInXingCheng;

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    visual: visualModule,
    monitor: monitor,
    // 可以添加其他的模块
  },
  state: {
    VUE_APP_AI_LINK_1: VUE_APP_AI_LINK_1 || 'http://10.0.96.249:1731',
    globalModalData: {
      isShow: false,
      text: ''
    },
    region,
    edition: VUE_APP_EDITION,
    updateTime: VUE_APP_UPDATE_TIME,
    clientId: CLIENT_ID,
    searchparams: JSON.parse(getLocalStoragItem('searchparams')), // 记录区域管理搜索条件
    isloading: false,
    isloadingdetail: false,
    userInfor: JSON.parse(getLocalStoragItem('userinfor')), // 登陆者信息
    ucloundid: getLocalStoragItem('ucloundid'), // 用户id
    token: getLocalStoragItem('token'), // token
    aiToken: getLocalStoragItem('aiToken') || '', // AI token
    aiTokenExpireTime: Number(getLocalStoragItem('aiTokenExpireTime')) || 0, // AI token 过期时间戳
    lang: getLang(), // 语言版本
    projectcode: getLocalStoragItem('projectcode'), // 项目号
    projectinfor: JSON.parse(getLocalStoragItem('projectinfor')), // 项目信息
    baseData: {}, // GetBaseData
    errorInfor: [], // SystemStatusList
    deviceType: [], // DeviceTypeList
    protocolType: [], // ProtocolTypeList
    deviceLogLevel: [], // DeviceLogLevel
    systemModule: [], // SystemModuleList
    userActionType: [], // UserActionTypeList
    ipConfig:{}, //ip配置映射
    rightStatusCode: 0, // 操作成功的状态码值
    ifttt3StatusCode:15086, // 3.0的状态码值
    ifttt3StatusCode2:17009,
    tokenMiss: [12004, 12005, 12006, 12007, 12008], // token过期的状态码值
    systemError: 10099, // 系统异常
    channleid: 65535, // 不是回路的channleid
    deviceCategoryList: [],
    userRole: [
      {
        rolevalue: 2,
        rolename: '安装者',
      },
      {
        rolevalue: 3,
        rolename: '项目管理员',
      },
      {
        rolevalue: 4,
        rolename: '普通用户',
      },
    ],
    oldDevice: [], // 只保存第一页设备
    // host:window["host"] || 'https://iot.opple.com',
    // host: window.host || 'https://debug1.opple.com',
    host: VUE_APP_host || window.host || window.location.origin,
    // host:window["host"] || '',
    // pichost: window.picHost || 'https://iot.opple.com', // ||'http://139.219.226.99:8085', //图片地址
    pichost: VUE_APP_picHost || window.picHost, // ||'http://139.219.226.99:8085', //图片地址
    fileRootPath: getLocalStoragItem('fileRootPath') || 'https://appresource.opple.com',
    apibase: '', // 请求基地址
    userhead: '', // 头像地址
    routermsg: getLocalStoragItem('routermsg'), // 路由高亮选中
    socketmodel: null, // socket接收到的对象
    socketparams: [], // socket参数  socket断开后重连的注册参数
    isregistersocket: true, // 解决不停注册socket的问题
    isLocalServer: isLocalServer() || window.isLocalServer || false, // 是否本地服务
    isDebugMode: window.isDebugMode || false, // 是否开发模式
    areasGpName: {}, // 缓存区域数据（"Gpno":GpName）
    deployParamter: {
      ifttt: {
        triggershowtotal: window.triggershowtotal,
        actionshowtotal: window.actionshowtotal,
        illuminationlimit: window.illuminationLimit,
        rhythmlimit: window.rhythmLimit,
      },
    },
    thirdSkuMarkTag: window.thirdskumarktag || '0x001F', // 第三方设备标记
    abroadLimitLang: window.abroadLimitLang || ['en-us'], // 限制版本
    isDebugEnv: false, // false, // location.host.startsWith('debug'),
    pageTotalLimit: window.pageTotalLimit || 30000, // 翻页显示数量
    powerPerfix: 'Opple_', // 权限标记 PowerPerfix
    projectarealevel: 4, // 项目区域层数（默认4层） 商务4 家居2
    systemNotices: window.systemNotices || null, // 系统公告
    systemNoticesReset: window.systemNoticesReset || null, // 系统公告重启
    isLimitOTA: window.isLimitOTA || false, // 限制系统OTA升级入口
    isShowAreaQrCode: window.isShowAreaQrCode || false, // 区域二维码出现
    routerHome: 'login', // 异常返回回路地址
    systemjsuuid: '', // js唯一标识
    nickName: '',
    isNoShowDeleTip: false,
    positionCountry: null, // 定位国家
    positionCity: null, // 定位城市
    GPS: null,
    qrcode: null,
    otaupdatelimitlist: window.otaupdatelimitlist || [1, 8], // GATT = 1,BLEMESH = 2,AP = 4,OBus = 8
    isWXApp: false, // 是否是微信小程序 （api可否调用wx）
    isQrLimitAbroad: window.isQrLimitAbroad || false,
    isHasWarning: JSON.parse(getLocalStoragItem('hasWarning')) == true || false, // 设备故障侧边栏提示红点 true显示 false不显示
    isRouterAlive: true,
    appDocumentWidth: document.documentElement.scrollWidth,
    // ipConfig: getLocalStoragItem('ipConfig') || '', //记录登录后的hostname判定二次进入域名是否需要跳转
    IP1: window.ip1 || 'iot1', //欧洲IP
    IP2: window.ip2 || 'iot2', //国内IP
    isIot1: isIot1(),
    isIot3: isIot3(),
    // ipConfigOpen:window.ipConfigOpen  || false, //request域名切换开关,目前iot1iot2都是开启的
    ipConfigOpen: VUE_APP_ipConfigOpen === 'true' || false, //request域名切换开关,目前iot1iot2都是开启的
    chooseIsEurope: null, //login选择欧洲国家
    bowerHostname: isInEurope ? ip1 : ip2, //浏览器内的hostname 用来和IP1/IP2对比
    isInEurope: isInEurope, // 是否是欧洲项目
    hiddenPhone: true, //2023年330暂时为关闭，手机号登录总开关 false为隐藏 true为显示
    staticConfig: JSON.parse(getLocalStoragItem('staticConfig')), //参数配置 （区控、场景总控）
    isProfessional: getLocalStoragItem('opple-isProfessional') === 1,
    colorTemperatureRange: { Min: 1800, Max: 12000 }, // isNoLimit === false ? { Min: 2700, Max: 6500 } : { Min: 1800, Max: 12000 },
    notReadCount: 0,
    isNoLimit: isNoLimit || false, // 欧洲版本 false欧洲 true国内
    isPassPermission: isIot1() || false, // 是否跳过权限校验 欧洲部分功能不校验
    isInChina: JSON.parse(getLocalStoragItem('isInChina')) || false, // 是否在中国
    //3D配置
    monitor3DConfig:false || isNoLimit,
    //设备安装-电子地图
    installMapConfig:true,
    //监控-电子地图
    monitorMapConfigw: true,
    //设备安装-电子地图-自动化全开全禁用
    installMapComponent:false || isNoLimit,
    //设备侧边栏、故障权限、故障推送
    deviceFaultConfig:false || isNoLimit,
    //灯带场景
    lightStripSceneConfig:false || isNoLimit,
    //图片场景
    picSceneConfig: false || isNoLimit,
    //节目单 
    programListConfig: false || isNoLimit,
    //订阅配置、订阅消息
    subscribeConfig: false || isNoLimit,
    //节律最大节点国内30欧洲10、节律色温范围
    rhythmConfig:false || isNoLimit,
    //信号强度
    signalStrengthConfig:false || isNoLimit,
    //华为
    huaweiConfig:false || isNoLimit,
    //区控色温范围
    areaControlConfig:false || isNoLimit,
    //能耗可视化v2.0
    monitorPowerConfig: true,
    //能耗可视化v1.0
    monitorPowerConfig1: false,
    /* 
     *能耗统计配置
     *隐藏碳排放量 、碳排放余额、碳足迹
     *隐藏能耗定额量配置（能耗单位、碳排放单位）
     *隐藏能耗定额/碳排放配置
     *隐藏统计对象
     *隐藏导出报表
    */
    energyStatisticsConfig: false || isNoLimit,
    // energyStatisticsConfig:false,
    deiveStatus: JSON.parse(getLocalStoragItem('DeiveStatusList')|| '[{"Key":"0x0207","Value":[{"Key":"闭合","Value":1},{"Key":"断开","Value":0}]}]'),

    //电子地图主题背景
    visvalTheme:THEME.WHITE,
    //电子地图是否聚合
    mapGroup: localStorage.getItem('opple-isMapGroup') !== '0',
    // 是否显示侧边栏
    isShowSidebar, 
    // 是否显示头部
    isShowHeader:false, 
    // 在星辰
    isInXingCheng:false,

    checkedArea:'',

    //esc事件戳
    escTime:'',
    // 地图初始大小
    mapInitScale: 0.5,
    //能耗统计全量统计是否打开
    enableFullEnergyConsumptionCalculation:false,
    //星辰上线后 国内需要去掉登陆注册等页面 需要考虑国外  &&  isIot2()
    starOnline: false,
    starRuiyiOld: false, // 是否是星辰睿易旧版本  星辰老项目进来不隐藏电子地图相关按钮
    starOtherParams:[], // 星辰其他参数
    // 自动化添加天幕视频场景支持预览，自动化其他天幕视频界面不支持预览
    isSupportPreview:false,
  },
  mutations: {
    setIsSupportPreview(state, payload) {
      state.isSupportPreview = payload
    },
    setEscTime(state, payload) {
      state.escTime = payload
    },
    setCheckedArea(state, payload) {
      state.checkedArea = payload
    },
    // 定义一个mutation来更新globalModalData  
    setGlobalModalData(state, payload) {  
      state.globalModalData.text = payload.msg; 
      state.globalModalData.isShow = payload.isShow;
    },
    setFileRootPath(state, payload) {
      state.fileRootPath = payload
      setLocalStoragItem('fileRootPath', JSON.stringify(payload))
    },
    setNotReadCount(state, payload) {
      state.notReadCount = payload.notReadCount
    },
    setIsEurope(state, payload) {
      let country
      let countryList = state?.baseData?.CountryList?state.baseData.CountryList : []
      try {
        country = countryList.find(item => item.CountryCode === payload)
      } catch (error) {
        /* 抛出错误禁止跳转 */
        country = false
      }
      state.chooseIsEurope = !!(country && country.IsEurope)
    },
    setHasWarning(state, payload) {
      state.isHasWarning = payload
      setLocalStoragItem('hasWarning', JSON.stringify(payload))
    },
    setParas(state, payload) {
      state.searchparams = payload
      setLocalStoragItem('searchparams', JSON.stringify(payload))
    },
    setIsregisterSocket(state, payload) {
      state.isregistersocket = payload
    },
    setUserhead(state, payload) {
      state.userhead = payload;
    },
    setoldDevice(state, payload) {
      state.oldDevice = payload
    },
    setadminUser(state, payload) {
      state.ucloundid = payload.UCloudId
      state.token = payload.Token
      setLocalStoragItem('token', payload.Token)
      setLocalStoragItem('ucloundid', payload.UCloudId)
      setLocalStoragItem('refreshToken', payload.RefreshToken)
      state.aiToken = ''
      state.aiTokenExpireTime = 0
      setLocalStoragItem('aiToken', '')
      setLocalStoragItem('aiTokenExpireTime', '0')
      // 火山引擎更新用户标识
      browserClient('config', {
        userId: payload.UCloudId || '',
      })
    },
    setAIToken(state, payload) {
      state.aiToken = payload.access_token || ''
      state.aiTokenExpireTime = Date.now() + (payload.expires_in || 0) * 1000
      setLocalStoragItem('aiToken', state.aiToken)
      setLocalStoragItem('aiTokenExpireTime', String(state.aiTokenExpireTime))
    },
    setuserfor(state, payload) {
      state.userInfor = payload
      setLocalStoragItem('userinfor', JSON.stringify(payload))
    },
    setStaticConfig(state, payload) {
      state.staticConfig = JSON.parse(payload)
      setLocalStoragItem('staticConfig', payload)
    },
    setLoading(state, payload) {
      state.isloading = payload
    },
    setLoadingdetail(state, payload) {
      state.isloadingdetail = payload
    },
    setLang(state, payload) {
      state.lang = payload
      setLocalStoragItem('lang', payload)
    },
    setErrorInfor(state, payload) {
      state.errorInfor = payload
    },
    setBaseData(state, payload) {
      state.baseData = payload
    },
    setDeiveStatus(state, payload) {
      state.deiveStatus = payload
    },
    setDeviceCategoryList(state, payload) {
      state.deviceCategoryList = payload
    },

    setDeviceType(state, payload) {
      state.deviceType = payload
    },
    setProtocolType(state, payload) {
      state.protocolType = payload
    },
    setDeviceLogLevel(state, payload) {
      state.deviceLogLevel = payload
    },
    setSystemModule(state, payload) {
      state.systemModule = payload
    },
    setUserActionType(state, payload) {
      state.userActionType = payload
    },
    setIpRegion(state, payload) {
      state.ipConfig = payload
    },

    setSock(state, payload) {
      state.socketmodel = payload
    },
    setProjectcode(state, payload) {
      state.projectcode = payload
      setLocalStoragItem('projectcode', payload)
      browserClient('context.set', 'projectID', payload || '') // 更新火山引擎项目号
    },
    setProjectinfor(state, payload) {
      state.projectinfor = payload
      setLocalStoragItem('projectinfor', JSON.stringify(payload))
      if (payload.CountryItem != null && !!payload.CountryItem.CountryCode) {
        state.isInChina = (payload.CountryItem.CountryCode === 'CN')
        setLocalStoragItem('isInChina', JSON.stringify(state.isInChina));
      }
      if (typeof payload.IsEurope !== 'undefined') {
        state.isNoLimit = payload.IsEurope != true
        setLocalStoragItem('isNoLimit', JSON.stringify(state.isNoLimit));
      } else if (payload.CountryItem != null && typeof payload.CountryItem.IsEurope !== 'undefined') {
        state.isNoLimit = payload.CountryItem.IsEurope != true
        setLocalStoragItem('isNoLimit', JSON.stringify(state.isNoLimit));
      } else {
        state.isNoLimit = state.abroadLimitLang.indexOf(state.lang) < 0
        setLocalStoragItem('isNoLimit', JSON.stringify(state.isNoLimit));
      }
      
      if(payload.hasOwnProperty('EnableOffHoursEnergySavingRateCalculation')){
        state.enableFullEnergyConsumptionCalculation = payload.EnableOffHoursEnergySavingRateCalculation
        // 欧洲项目强制不显示改造节能
        if( !state.isNoLimit){
          state.enableFullEnergyConsumptionCalculation =false
        }
      }

      this.commit('setIsNoLimit', state.isNoLimit)
    },
    setRoutermsg(state, payload) {
      setLocalStoragItem('routermsg', payload)
      state.routermsg = payload
    },
    setGpName(state, payload) {
      state.areasGpName[payload.Gpno] = payload
    },
    setIsNoLimit(state, payload) {
      state.isNoLimit = payload == true
      state.monitor3DConfig = state.isNoLimit
      state.installMapComponent = state.isNoLimit
      state.lightStripSceneConfig = state.isNoLimit
      state.deviceFaultConfig = state.isNoLimit
      state.subscribeConfig = state.isNoLimit
      state.picSceneConfig = state.isNoLimit
      state.programListConfig = state.isNoLimit
      state.rhythmConfig = state.isNoLimit
      state.signalStrengthConfig = state.isNoLimit
      state.huaweiConfig = state.isNoLimit
      state.areaControlConfig = state.isNoLimit
      state.energyStatisticsConfig = state.isNoLimit
      setLocalStoragItem('isNoLimit', JSON.stringify(payload == true))
    },
    setPowerPerfix(state, payload) {
      state.powerPerfix = payload
    },
    setRouteShow(state, payload) {
      state.isRouterAlive = payload
    },
    setAppDocumentWidth(state, payload) {
      state.appDocumentWidth = payload
    },
    changeTheme(state, payload){
      state.visvalTheme = payload
    },
    // 是否显示侧边栏
    setIsShowSidebar(state, payload) {
      state.isShowSidebar = payload;
    },
    // 是否显示头部
    setIsShowHeader(state, payload) {
      state.isShowHeader = payload;
    },

    setInXingCheng(state) { 
      state.isInXingCheng = true
      window.isInXingCheng = true;
      state.isShowHeader = false;
      // localStorage.setItem('isInXingCheng', 'true')
    },

    updateMapGroup(state, val) {
      state.mapGroup = val
    },

    updateMapInitScale(state, val) {
      state.mapInitScale = val
    },
  
    setEnableFullEnergyConsumptionCalculation(state,val){
      state.enableFullEnergyConsumptionCalculation = val
    },
    setLocationAddress(state,val){
      const {cnty,location} = val;
      state.positionCountry = cnty || null
      state.positionCity = location || null
    },
    setStarRuiyiOld(state, payload) {
      state.starRuiyiOld = payload
    },
    setStarOtherParams(state, payload) {
      if(payload && typeof payload === 'string') {
        state.starOtherParams = payload.split(',').map(item => item.trim());
      }
    }
  },
  actions: {
    changeIsregisterSocket(store, data) {
      store.commit('setIsregisterSocket', data)
    },
    changeUserhead(store, data) {
      store.commit('setUserhead', data)
    },
    changeoldDevice(store, data) {
      store.commit('setoldDevice', data)
    },
    changeLoading(store, data) {
      store.commit('setLoading', data)
    },
    changeLoadingdetail(store, data) {
      store.commit('setLoadingdetail', data)
    },
    changeLang(store, data) {
      store.commit('setLang', data)
    },
    changeErrorInfor(store, data) {
      store.commit('setErrorInfor', data)
    },
    changeBaseData(store, data) {
      store.commit('setBaseData', data)
    },

    changeDeiveStatus(store, data) {
      store.commit('setDeiveStatus', data)
    },
    changeDeviceCategoryList(store, data) {
      store.commit('setDeviceCategoryList', data)
    },

    changeDeviceType(store, data) {
      store.commit('setDeviceType', data)
    },
    changeProtocolType(store, data) {
      store.commit('setProtocolType', data)
    },
    changeDeviceLogLevel(store, data) {
      store.commit('setDeviceLogLevel', data)
    },
    changeSystemModule(store, data) {
      store.commit('setSystemModule', data)
    },
    changeUserActionType(store, data) {
      store.commit('setUserActionType', data)
    },
    changeIpRegion(store, data) {
      store.commit('setIpRegion', data)
    },

    changeProjectinfor(store, data) {
      store.commit('setProjectinfor', data)
    },
    changeProjectcode(store, data) {
      store.commit('setProjectcode', data)
    },
    login(store, data) {
      store.commit('setadminUser', data)
      // return Promise.resolve({
      // 	status: 'ok'
      // });
    },
    loginByPhone(store, data) {
      store.commit('setadminUser', {
        ...data,
        Token: data.AccessToken
      })
      // return Promise.resolve({
      // 	status: 'ok'
      // });
    },
    changeUserinfor(store, data) {
      store.commit('setuserfor', data)
      // return Promise.resolve({
      // 	status: 'ok'
      // });
    },
    changeRoutermsg(store, data) {
      store.commit('setRoutermsg', data)
    },
    changeSocket(store, data) {
      store.commit('setSock', data)
    },
    changeSearchParas(store, data) {
      store.commit('setParas', data)
    },
    updateGpName(store, data) {
      store.commit('setGpName', data)
    },
    changeIsNoLimit(store, data) {
      store.commit('setIsNoLimit', data)
    },
    changePowerPerfix(store, data) {
      store.commit('setPowerPerfix', data)
    },
    refreshRoute(store) {
      store.commit('setRouteShow', false)
      Promise.resolve().then(() => store.commit('setRouteShow', true))
    },
    setInXingcheng(store) {
      // store.commit('setIsShowSidebar', false);
      // store.commit('setIsShowHeader', false);
    },
    
  },
  // 模块化管理vuex: https://vuex.vuejs.org/zh/guide/modules.html
  module: {},
  // 在严格模式下，无论何时发生了状态变更且不是由 mutation 函数引起的，将会抛出错误
  // 严格模式会深度监测状态树来检测不合规的状态变更——请确保在发布环境下关闭严格模式，以避免性能损失。
  strict: NODE_ENV !== 'production',
})
